<template>
    <div>
        <app-sub-title
            :text="'Formato: ' + formatTitle + ' [' + formatCode + ']'"
        />
        <b-btn
            variant="primary"
            @click="
                $router.push({
                    name: 'formatDetailList',
                    params: { formatId: formatId },
                })
            "
            title="Volver"
        >
            <i class="fa fa-arrow-left"></i>
        </b-btn>
        <b-btn variant="primary" @click="print" title="Descargar">
            <i class="fa fa-print"></i>
        </b-btn>

        <b-card>
            <b-card-body>
                <b-row v-for="field in tempData" :key="field.id">
                    <b-col cols="12">
                        <b-form-group
                            :label="field.label"
                            :label-for="field.label"
                        >
                            <b-form-input
                                type="text"
                                readonly
                                :value="field.response"
                            >
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <b-form-group label="Firma" label-for="Firma">
                            <b-img :src="firm"></b-img>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </div>
</template>
<script>
export default {
    data() {
        return {
            data: [],
            firm: '',
            tempData: [],
        }
    },
    props: {
        formatId: {
            type: [Number, String],
            default: 0,
        },
        formatHeaderId: {
            type: [Number, String],
            default: 0,
        },
        formatTitle: {
            type: String,
            default: '',
        },
        formatCode: {
            type: String,
            default: '',
        },
    },
    methods: {
        async loadFields() {
            try {
                let tempFields = []
                const { data } = await repo.get(
                    `formats/format/${this.formatId}/load-fields-data`
                )
                tempFields = data

                tempFields.push(
                    { key: 'user_name', label: 'Nombre y Apellido' },
                    { key: 'created_at', label: 'Fecha y hora' }
                )
                this.fields = tempFields
                // console.log('load fields es')
                // console.log(this.fields)
            } catch (err) {
                this.handleErrors(err)
            }
        },
        async loadResponse() {
            try {
                const { data } = await repo.get(
                    `formats/format/${this.formatHeaderId}/get-response`
                )
                let response = ''
                this.firm = data.signature_url
                response = JSON.parse(data.details)
                this.data = response.response.map(item => {
                    let field = this.fields.find(fieldItem => {
                        return fieldItem.key == item.format_fields_id
                    })
                    if (field) {
                        console.log(field)
                        this.tempData.push({
                            id: item.format_fields_id,
                            response: item.value,
                            label: field.label,
                        })
                    }
                })
                // console.log('final es:')
                // console.log(this.tempData)
            } catch (err) {
                this.handleErrors(err)
            }
        },

        print() {
            window.print()
        },
    },
    created() {},
    async mounted() {
        await Promise.all([this.loadFields(), this.loadResponse()])
    },
}
</script>
